import ModelTypeConstants from 'constants/ModelTypeConstants';
import BaseAnalyticsListingRenderer from 'insights/sidepanel/BaseAnalyticsListingRenderer';
import {ListingRendererType} from 'nav/expanded/ListingRendererConstants';
import {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';

export default class AnalysisListingRenderer extends BaseAnalyticsListingRenderer<ListingRendererType.ANALYSIS> {
  listingRendererType = ListingRendererType.ANALYSIS;
  icon: BenchlingIconName = ModelTypeConstants.ANALYSIS;
}
